module.exports = __webpack_public_path__ + "static/MortgageAwardsWinners2023-Bank_Mortgage_Provider_of_the_Year-c5c38084263d20dcd3478f20f45912e8.jpg";